export default {

    filters: {
        capitalize: function (value) {
            if ( ! value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },

        convertArrayToStringWithNewLineForEachElement: function (array) {
            return array.toString().replaceAll(',', '\n')
        },

        removeParenthesis: function (value) {
            if ( ! value) return ''
            value = value.toString()
            return value.replaceAll('(', '').replaceAll(')', '')
        },
        trim: function (value) {
            if ( ! value) return ''
            return value.trim()
        }
    },

    methods: {

        // Converts 7:00 to 07:00
        prependHourLeadingZeroFor24HoursTimeFormat(timeString) {

            let timeArray = timeString.split(':');
            if (timeArray.length === 2 && timeArray[0].length === 1) {
                timeString = '0' + timeString
            }

            return timeString

        },

        generateRandomString: (length) => {

            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

            let result = '';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            return result;

        }

    }

}
